import { acceptedModeMapper } from "src/app/features/Contract/services/mappers/ContractDtoToEntity";
import type { ContractAppProfileEntity } from "src/app/features/Contract/types/subTypes/ContractAppProfileEntity";
import type { ContractProfileDto } from "../../types/ContractProfileDto";
import type { ContractProfileEntity } from "../../types/ContractProfileEntity";

export const ContractProfileDtoToEntity = ({ acceptedCardProfiles, ...rest }: Readonly<ContractProfileDto>): ContractProfileEntity => {
    const newContractAppProfiles: ContractAppProfileEntity[] =
        acceptedCardProfiles?.map((contractAppProfile) => {
            return acceptedModeMapper(contractAppProfile);
        }) || [];

    return { ...rest, acceptedCardProfiles: newContractAppProfiles };
};
